import { useMemo, useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viCalendar, viCheck, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddHolidaySetItem({ timetable, holidaySet, timetableDispatch }) {
  const [pending, setPending] = useState(false);

  const isActive = useMemo(
    () => timetable.holidaySets.find((_holidaySet) => _holidaySet.id === holidaySet.id),
    [holidaySet.id, timetable.holidaySets],
  );

  const toggleHolidaySet = () => {
    if (isActive) {
      setPending(true);

      Promise.resolve(Api.deleteTimetableHolidaySet(timetable, holidaySet))
        .then(() => timetableDispatch({ type: "removeHolidaySet", holidaySet }))
        .finally(() => setPending(false));
    } else {
      setPending(true);

      Promise.resolve(Api.postTimetableHolidaySet(timetable, holidaySet))
        .then(() => timetableDispatch({ type: "addHolidaySet", holidaySet }))
        .finally(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding key={holidaySet.id} sx={{ minHeight: 44 }}>
      <ListItemButton
        onClick={() => toggleHolidaySet(holidaySet)}
        disabled={pending || (timetable.holidaySets.length >= 4 && !isActive)}
        sx={{ minHeight: 44 }}
      >
        <ListItemAvatar sx={{ minWidth: 34 }}>
          <Avatar text={holidaySet.name} icon={viCalendar} px={24} />
        </ListItemAvatar>
        <ListItemText primary={holidaySet.name} />
        {(isActive || pending) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddHolidaySetItem.propTypes = {
  timetable: PropTypes.object,
  holidaySet: PropTypes.object,
  timetableDispatch: PropTypes.func,
};

export default AddHolidaySetItem;
